import { ArrowDownward } from '@material-ui/icons';
import React,{useState,useEffect,useRef} from 'react'
import { Container,Table, Row,Button, Modal,ModalFooter,ModalHeader,ModalBody, Label,Spinner,Input} from 'reactstrap'
import ReactDOM from "react-dom";
import { getAll } from 'network/ApiAxios';
import DatePicker from "react-datepicker";
import { getByDate,updateEvents,deleteEvent } from 'network/ApiAxiosSchedule';
import ToastComp from 'components/Reusable Components/ToastComp';
import HeaderEmpty from 'components/Headers/HeaderEmpty';
import Header from 'components/Headers/Header';

const houses = [
    {
        Name:'Albufeira66',
        Bars:['Day','Bar 1','Bar 2','Extras']
    },{
        Name:'Heaven',
        Bars:['Bar 1','Bar 2','Bar 3','Bar 4','VIP','Extras']
    },{
        Name:'Albufissa',
        Bars:['Bar 1','Bar 2','Extras']
    },{
        Name:'Warehouse',
        Bars:['Bar 1','Bar 2','Extras']
    },{
        Name:'Tropicana',
        Bars:['Bar 1','Bar 2','Bar 3','Extras']
    },{
        Name:'PoolParty',
        Bars:['Bar 1','Bar 2','VIP','Extras']
    }]

function MainSchedule() {
    const [open, setOpen] = useState('1');
    const [colapseRow, setColapseRow] = useState({Heaven:true,Albufeira66:true,Albufissa:true,Warehouse:true,Tropicana:true,PoolParty:true});
    const [weekCount, setWeekCount] = useState(0);
    const [users, setUsers] = useState('');
    const [modal, setModal] = useState(false);
    const [modalInfo, setModalInfo] = useState('');
    const [usersAll, setUsersAll] = useState('');
    const [defaultHours, setDefaultHours] = useState({
        poolparty: {
            sTime:new Date(2011, 0, 1, 14, 0, 0),
            eTime:new Date(2011, 0, 1, 20, 0, 0, 0)
        },albufeira: {
            sTime:new Date(2011, 0, 1, 19, 0, 0),
            eTime:new Date(2011, 0, 2, 4, 0, 0, 0)
        },heaven: {
            sTime:new Date(2011, 0, 1, 22, 0, 0),
            eTime:new Date(2011, 0, 2, 6, 0, 0, 0)
        },albufissa: {
            sTime:new Date(2011, 0, 1, 19, 0, 0),
            eTime:new Date(2011, 0, 2, 4, 0, 0, 0)
        },warehouse: {
            sTime:new Date(2011, 0, 1, 5, 0, 0),
            eTime:new Date(2011, 0, 2, 14, 0, 0, 0)
        },albufeiraday: {
            sTime:new Date(2011, 0, 1, 12, 0, 0),
            eTime:new Date(2011, 0, 1, 21, 0, 0, 0)
        },tropicana: {
            sTime:new Date(2011, 0, 1, 22, 0, 0),
            eTime:new Date(2011, 0, 2, 6, 0, 0, 0)
        }
    });
    const [modalStartTime, setModalStartTime] = useState(new Date());
    const [modalEndTime, setModalEndTime] = useState(new Date());
    const [spinnerModal, setSpinnerModal] = useState(false);
    const [modalDesc, setModalDesc] = useState('');
    const [toast, setToast] = useState('');
    const tableRef = useRef()

    const toggleModal = () => setModal(!modal);
    const toggleSpinnerModal = () => {
        console.log('before-------',spinnerModal)
        setSpinnerModal(!spinnerModal);
        console.log('after-------',spinnerModal)
    }

    useEffect(() => {
        //toggleSpinnerModal()
        getEmployees()
        fecthScheduleEvents()
        //toggleSpinnerModal()
    }, [])

    const role = JSON.parse(localStorage.getItem('user')).role
    
    const toggle = (id) => {
        if (open === id) {
        setOpen();
        } else {
        setOpen(id);
        }
    };

    function allowDrop(ev) {
        ev.preventDefault();
        ev.target.style.backgroundColor = 'lightblue'
    }

    function dragExit(ev) {
        ev.preventDefault();
        ev.target.style.backgroundColor = 'transparent'
    }
    
    function drag(ev) {
        ev.dataTransfer.setData("text", ev.target.id);
    }
    
    function drop(ev) {
        ev.preventDefault();
        var data = ev.dataTransfer.getData("text");
        let target = ev.target.id

        let time = getDefaultTime(target)

        let docToAppend = document.getElementById(data)
        //docToAppend.insertAdjacentText('afterbegin','testeee')


        if(ev.ctrlKey && docToAppend.id.split('?')[3] != undefined){
            if(docToAppend.childElementCount == 1){
                docToAppend = docToAppend.cloneNode({deep:true})
                docToAppend.addEventListener('contextmenu',(ev)=>deleteDiv(ev))
                docToAppend.addEventListener('dblclick',empClick)
                docToAppend.setAttribute('draggable','true')
                docToAppend.addEventListener('dragstart',(event)=>drag(event))
                docToAppend.addEventListener('drop',()=>{return false})
                docToAppend.id = docToAppend.id+'?c'
                //docToAppend.innerHTML = 'something'
                //docToAppend.insertAdjacentHTML('afterend','teste')
                
                docToAppend.firstChild.addEventListener('dblclick',empClick)
                docToAppend.firstChild.setAttribute('draggable','true')
                docToAppend.firstChild.addEventListener('contextmenu',(ev)=>deleteDiv(ev))
                docToAppend.firstChild.addEventListener('dragstart',(event)=>drag(event))
                docToAppend.firstChild.addEventListener('drop',()=>{return false})
                docToAppend.firstChild.id = docToAppend.firstChild.id+'?c'
                
                
                docToAppend.dataset.value = JSON.stringify(time)
                docToAppend.firstChild.dataset.value = JSON.stringify(time)
                
            }else{
                docToAppend = docToAppend.parentElement
                docToAppend.cloneNode({deep:true})
                docToAppend.addEventListener('contextmenu',(ev)=>deleteDiv(ev))
                docToAppend.addEventListener('dblclick',empClick)
                docToAppend.setAttribute('draggable','true')
                docToAppend.addEventListener('dragstart',(event)=>drag(event))
                docToAppend.addEventListener('drop',()=>{return false})
                docToAppend.id = docToAppend.id+'?c'
                //docToAppend.innerText = 'something'

                docToAppend.firstChild.addEventListener('dblclick',empClick)
                docToAppend.firstChild.addEventListener('contextmenu',(ev)=>deleteDiv(ev))
                docToAppend.firstChild.setAttribute('draggable','true')
                docToAppend.firstChild.addEventListener('dragstart',(event)=>drag(event))
                docToAppend.firstChild.addEventListener('drop',()=>{return false})
                docToAppend.firstChild.id = docToAppend.firstChild.id+'?c'

                
                docToAppend.dataset.value = JSON.stringify(time)
                docToAppend.firstChild.dataset.value = JSON.stringify(time)
                
            }
        }else{
            docToAppend.addEventListener('drop',()=>{return false})
            docToAppend.id = docToAppend.id+'?c'
            docToAppend.firstChild.addEventListener('drop',()=>{return false})
            docToAppend.firstChild.id = docToAppend.firstChild.id+'?c'
            docToAppend.dataset.value = JSON.stringify(time)
            docToAppend.children[0].dataset.value = JSON.stringify(time)
            //docToAppend.innerText = 'something'
            
        }
        ev.target.appendChild(docToAppend);
    }
    
    const getDefaultTime = (target)=>{
        let time
        if(target.split('?')[1] == 'Day'){
            time = defaultHours.albufeiraday
        }else {
            if(target.split('?')[0] == 'Albufeira66'){
            time = defaultHours.albufeira
            }else if(target.split('?')[0] == 'Heaven'){
                time = defaultHours.heaven
            }else if(target.split('?')[0] == 'Albufissa'){
                time = defaultHours.albufissa
            }else if(target.split('?')[0] == 'Warehouse'){
                time = defaultHours.warehouse
            }else if(target.split('?')[0] == 'Tropicana'){
                time = defaultHours.tropicana
            }else if(target.split('?')[0] == 'PoolParty'){
                time = defaultHours.poolparty
            }
        }

        const targetDateDay = target.split('?')[2].split('/')[0]
        const targetDateMonth = target.split('?')[2].split('/')[1]
        const targetDateYear = target.split('?')[2].split('/')[2]

        const sTimeHours = time.sTime.getHours()
        const sTimeMin = time.sTime.getMinutes()

        const timeDiff = Date.parse(time.eTime) - Date.parse(time.sTime)

        const combinedStartTime = new Date(targetDateYear,targetDateMonth - 1,targetDateDay,sTimeHours,sTimeMin)
        const combinedEndTime = new Date(Date.parse(combinedStartTime) + timeDiff)

        time.sTime = combinedStartTime
        time.eTime = combinedEndTime

        return time
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    const today = new Date();
    const first = today.getDate() - today.getDay() + 1 ;

    const monday = new Date(today.setDate(first));

    const nextWeek =async()=>{
        setWeekCount(weekCount+7)
        const cleaned = await cleanTableContent()
        if(cleaned) fecthScheduleEvents(addDays(monday,weekCount+7))
    }

    const previousWeek = async()=>{
        setWeekCount(weekCount-7)
        const cleaned = await cleanTableContent()
        if(cleaned) fecthScheduleEvents(addDays(monday,weekCount-7))
    }

    const cleanTableContent =()=>{
        console.log('clean')
        const tableBody = tableRef.current.children[1]
        const tableRows = Array.from(tableBody.children)
        tableRows.map((row,rowIndex)=>{
            const rowNodes = Array.from(row.querySelectorAll('td'))
            rowNodes.map((tableCell,cellIndex)=>{
                if(tableCell.querySelectorAll('div').length > 0){
                    document.getElementById(tableCell.id).replaceChildren()
                }
            })
        })
        return true
    }

    const tableHeaders =()=>{
        return<thead>
            <tr>
                <th id='ddddd' className='text-center align-middle'  draggable onDragStart={(event)=>drag(event)} >
                    <ArrowDownward onClick={previousWeek} className='mr-2'  style={{transform: 'rotate(90deg)'}} />
                    Week
                    <ArrowDownward onClick={nextWeek} className='ml-2' style={{transform: 'rotate(-90deg)'}} />
                    
                </th>
                <th className='text-center'>
                    <h4>Monday</h4>
                    <p>{addDays(monday,weekCount).toLocaleDateString('en-GB')}</p>
                </th>
                <th className='text-center'>
                    <h4>Tuesday</h4>
                    <p>{addDays(monday,weekCount + 1).toLocaleDateString('en-GB')}</p>
                </th>
                <th className='text-center'>
                    <h4>Wednesday</h4>
                    <p>{addDays(monday,weekCount + 2).toLocaleDateString('en-GB')}</p>
                </th>
                <th className='text-center'>
                    <h4>Thursday</h4>
                    <p>{addDays(monday,weekCount + 3).toLocaleDateString('en-GB')}</p>
                </th>
                <th className='text-center'>
                    <h4>Friday</h4>
                    <p>{addDays(monday,weekCount + 4).toLocaleDateString('en-GB')}</p>
                </th>
                <th className='text-center'>
                    <h4>Saturday</h4>
                    <p>{addDays(monday,weekCount + 5).toLocaleDateString('en-GB')}</p>
                </th>
                <th className='text-center'>
                    <h4>Sunday</h4>
                    <p>{addDays(monday,weekCount + 6).toLocaleDateString('en-GB')}</p>
                </th>
            </tr>
        </thead>
    }

    const tableHouseRow =(house)=>{
        return<tr >
                <th key={house} colSpan="8" scope="row" id='heaven' onClick={(e)=>  {
                    setColapseRow(prev=>({...prev,[house.Name]:!colapseRow[house.Name]}))
                    setUsers(usersAll.filter((item)=> item.house == house.Name))
                    } }>
                    {house.Name} <ArrowDownward  style={colapseRow[house.Name] ? {transform: 'rotate(-90deg)'} : {transform: 'rotate(0)'}} />
                </th>
            </tr>
    }

    const tableBody = ()=>{
        return houses.map((house,houseIndex)=>{
            
             return <>
                {tableHouseRow(house)}
                {house.Bars.map((bar)=>{
                    return <tr key={bar} hidden={colapseRow[house.Name]}  >
                        <th scope="row">
                            {bar}
                        </th>
                        <td id={house.Name + '?' + bar + '?' + addDays(monday,weekCount).toLocaleDateString('en-GB')} onDrop={(event)=>drop(event)} onDragLeave={(event)=>dragExit(event)} onDragOver={(event)=>allowDrop(event)} >
                            
                        </td>
                        <td id={house.Name + '?' + bar + '?' + addDays(monday,weekCount + 1).toLocaleDateString('en-GB')} onDrop={(event)=>drop(event)} onDragLeave={(event)=>dragExit(event)} onDragOver={(event)=>allowDrop(event)}  >
                            
                        </td>
                        <td id={house.Name + '?' + bar + '?' + addDays(monday,weekCount + 2).toLocaleDateString('en-GB')  } onDrop={(event)=>drop(event)} onDragLeave={(event)=>dragExit(event)} onDragOver={(event)=>allowDrop(event)}  >
                            
                        </td>
                        <td id={house.Name + '?' + bar + '?' + addDays(monday,weekCount + 3).toLocaleDateString('en-GB') } onDrop={(event)=>drop(event)} onDragLeave={(event)=>dragExit(event)} onDragOver={(event)=>allowDrop(event)}  >
                            
                        </td>
                        <td id={house.Name + '?' + bar + '?' + addDays(monday,weekCount + 4).toLocaleDateString('en-GB')} onDrop={(event)=>drop(event)} onDragLeave={(event)=>dragExit(event)} onDragOver={(event)=>allowDrop(event)}  >
                            
                        </td>
                        <td id={house.Name + '?' + bar + '?' + addDays(monday,weekCount + 5).toLocaleDateString('en-GB') } onDrop={(event)=>drop(event)} onDragLeave={(event)=>dragExit(event)} onDragOver={(event)=>allowDrop(event)}  >
                            
                        </td>
                        <td id={house.Name + '?' + bar + '?' + addDays(monday,weekCount + 6).toLocaleDateString('en-GB')} onDrop={(event)=>drop(event)} onDragLeave={(event)=>dragExit(event)} onDragOver={(event)=>allowDrop(event)}  >
                            
                        </td>
                    </tr>
                })}
            </> 
        })
    }

    const empDivJsx = (id)=>{
        let time
        if(id.data.data){
            time = id.data.time
            const name = id.data.data.split('?')[1]
            id=id.data.data
            id=id+'?c'
            return <div id={id} onDoubleClick={empClick} oncontextmenu={deleteDiv(ev)} data-value={JSON.stringify(time)} style={{width:'100px'}} draggable onDragStart={(event)=>drag(event)} className='text-center' >
                <p id={id} onDoubleClick={empClick} oncontextmenu={deleteDiv(ev)} className='bg-white' data-value={JSON.stringify(time)} style={{whiteSpace:'pre-wrap'}} draggable onDragStart={(event)=>drag(event)}>{name}</p>
            </div>
        }else{
            time = id.time
            const name = id.data.split('?')[1]
            id=id.data
            id=id+'?c'
            return <div id={id} onDoubleClick={empClick} oncontextmenu={deleteDiv(ev)} data-value={JSON.stringify(time)} style={{width:'100px'}} draggable onDragStart={(event)=>drag(event)} className='text-center' >
                <p id={id} onDoubleClick={empClick} oncontextmenu={deleteDiv(ev)} className='bg-white' data-value={JSON.stringify(time)} style={{whiteSpace:'pre-wrap'}} draggable onDragStart={(event)=>drag(event)}>{name}</p>
            </div>
        }
        
    }

    const empDivJsxInitial = (id)=>{
        const name = id.split('?')[1]
        id=id
        return <div key={id} id={id} onDoubleClick={empClick} onContextMenu={deleteDiv} data-value="test" style={{width:'100px', backgroundColor:'white'}} draggable onDragStart={(event)=>drag(event)} className='text-center ml-1 mr-1 mb-1' >
        <p key={id + 'p'} id={id} onDoubleClick={empClick} onContextMenu={deleteDiv} data-value="test" className='bg-white' style={{whiteSpace:'pre-wrap'}} draggable onDragStart={(event)=>drag(event)}>{name}</p>
    </div>
    }

    const empClick=(e)=>{
        toggleModal()
        setModalInfo(e.target)

        setModalStartTime(new Date(JSON.parse(e.target.dataset.value).sTime))
        setModalEndTime(new Date(JSON.parse(e.target.dataset.value).eTime))
        setModalDesc(e.target.dataset.desc ? e.target.dataset.desc : '')

    }
    
    const saveTimeChange = (e)=>{
        const time = {
            sTime:modalStartTime,
            eTime:modalEndTime
        }
        if(modalInfo.tagName == 'P'){
            modalInfo.parentElement.dataset.value = JSON.stringify(time) //set the value of parent the div in this case
            modalInfo.parentElement.dataset.desc =  modalDesc//set the value of parent the div in this case
            modalInfo.dataset.value = JSON.stringify(time) //set the value
            modalInfo.dataset.desc = modalDesc //set the value
            toggleModal()
        }else{
            modalInfo.children[0].dataset.value = JSON.stringify(time) //set the value of parent the div in this case
            modalInfo.children[0].dataset.desc = modalDesc //set the value of parent the div in this case
            modalInfo.dataset.value = JSON.stringify(time) //set the value
            modalInfo.dataset.desc = modalDesc //set the value
            toggleModal()
        }
    }

    const getEmployees =async()=>{
        const resp = await getAll('scheduleUsers')
        if(resp.data?.success){
            setUsersAll(resp.data.users.sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ?  -1 :  1))
            setUsers(resp.data.users.sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ?  -1 :  1))
        }
    }

    const scanTable = async()=>{
        //toggleSpinnerModal()
        const tableBody = tableRef.current.children[1]
        let finalArr =[]
        const tableRows = Array.from(tableBody.children)
        tableRows.map((row,rowIndex)=>{
            const rowNodes = Array.from(row.querySelectorAll('td'))
            rowNodes.map((tableCell,cellIndex)=>{
                if(tableCell.querySelectorAll('div').length == 1){
                    const targetTableCell = row.querySelectorAll('td')
                    let cellId = targetTableCell[cellIndex].id
                    const empId = tableCell.querySelectorAll('div')[0].id
                    const cellIdd = cellId
                    const sTime = JSON.parse(tableCell.querySelectorAll('div')[0].dataset.value).sTime
                    const eTime = JSON.parse(tableCell.querySelectorAll('div')[0].dataset.value).eTime
                    const desc = tableCell.querySelectorAll('div')[0].dataset.desc ? tableCell.querySelectorAll('div')[0].dataset.desc : ''
                    
                    cellId=cellId.split('?')
                    finalArr.push({
                        userId: empId.split('?')[0],
                        elementId: empId,
                        targetId:cellIdd,
                        house:cellId[0],
                        bar:cellId[1],
                        date:cellId[2],
                        sTime,
                        eTime,
                        desc
                    })
                }else if(tableCell.querySelectorAll('div').length > 1){
                    const targetTableCellMulti = row.querySelectorAll('td')
                    let cellIdMulti = targetTableCellMulti[cellIndex].id
                    
                    const divArray = Array.from(tableCell.querySelectorAll('div'))
                    divArray.map((tableCellItem)=>{
                        const empId = tableCellItem.id
                        const cellIdd = cellIdMulti
                        const sTime = JSON.parse(tableCellItem.dataset.value).sTime
                        const eTime = JSON.parse(tableCellItem.dataset.value).eTime
                        const desc = tableCellItem.dataset.desc
                        finalArr.push({
                            userId: empId.split('?')[0],
                            elementId: empId,
                            targetId:cellIdd,
                            house:cellIdd.split('?')[0],
                            bar:cellIdd.split('?')[1],
                            date:cellIdd.split('?')[2],
                            sTime,
                            eTime,
                            desc
                        })

                    })
                }
            })
        })

        console.log(finalArr) //send this to back-end
        const resp = await updateEvents(finalArr)
        if(resp.data.success){
            //toggleSpinnerModal()
            setToast({type:'info',tittle:'Save Schedule',text:' Schedule was successefully saved!'})
        }else{
            setToast({type:'danger',tittle:'Save Schedule',text:' Schedule not saved something went wrong!'})
            //alert('Something went wrong please try again')
        }
    }

    const fecthScheduleEvents = async(date)=>{
        //toggleSpinnerModal()
        console.log("fetching")
        const resp = await getByDate(date ? date : addDays(monday,weekCount))
        if(resp.data.success){
            //fecth events from bd and fill schedule table
            console.log(resp.data.events)
            resp.data.events.map((evenItem)=>{
                console.log(document.getElementById(evenItem.targetId))
                
                if(document.getElementById(evenItem.targetId)){
                    const desc = evenItem.desc ? evenItem.desc : ''
                    const data= {data:evenItem.elementId,time:{sTime:evenItem.sTime,eTime:evenItem.eTime},desc}
        
                    let mainDiv = document.createElement('div')
                    mainDiv.id=evenItem.elementId
                    mainDiv.addEventListener('dblclick',empClick)
                    mainDiv.addEventListener('dragstart',drag)
                    mainDiv.addEventListener('contextmenu',(ev)=>deleteDiv(ev))
                    mainDiv.draggable=true
                    mainDiv.dataset.value=JSON.stringify(data.time)
                    data.desc ? mainDiv.dataset.desc=data.desc : null
                    mainDiv.className = 'text-center'
                    mainDiv.style.width = '100px'
        
        
                    let pTag = document.createElement('p')
                    pTag.id=evenItem.elementId
                    pTag.addEventListener('dblclick',empClick)
                    pTag.addEventListener('dragstart',drag)
                    pTag.addEventListener('contextmenu',(ev)=>deleteDiv(ev))
                    pTag.draggable=true
                    pTag.dataset.value=JSON.stringify(data.time)
                    data.desc ? pTag.dataset.desc=data.desc : null
                    pTag.style.whiteSpace= 'pre-wrap'
                    pTag.innerHTML= evenItem.elementId.split('?')[1]
                    pTag.className = 'bg-white'
        
                    mainDiv.appendChild(pTag)
        
                    document.getElementById(evenItem.targetId).appendChild(mainDiv)
    
                }
            })
            console.log("fetching 2")
            
        }
        //toggleSpinnerModal()

        console.log("fetching 3")

    }

    const copyLastWeek = async ()=>{
        //toggleSpinnerModal()
        const resp = await getByDate(addDays(monday,weekCount - 7))
        if(resp.data.success){
            //fecth events from bd and fill schedule table
            resp.data.events.map((evenItem)=>{
                const pastTargetDateString = evenItem.targetId.split('?')[2]
                const pastTargetYear = pastTargetDateString.split('/')[2]
                const pastTargetMonth = parseInt(pastTargetDateString.split('/')[1]) - 1
                const pastTargetDay = pastTargetDateString.split('/')[0]
                const pastTargetDate = new Date(pastTargetYear,pastTargetMonth,pastTargetDay)
                const newCurrentTargetDate = addDays(pastTargetDate,7)
                
                evenItem.targetId = evenItem.targetId.split('?')[0] + '?' + evenItem.targetId.split('?')[1] + '?' + newCurrentTargetDate.toLocaleDateString('en-GB')
                
                if(document.getElementById(evenItem.targetId)){
                    const desc = ''
                    const data= {data:evenItem.elementId,time:getDefaultTime(evenItem.targetId),desc}
        
                    let mainDiv = document.createElement('div')
                    mainDiv.id=evenItem.elementId
                    mainDiv.addEventListener('dblclick',empClick)
                    mainDiv.addEventListener('dragstart',drag)
                    mainDiv.addEventListener('contextmenu',(ev)=>deleteDiv(ev))
                    mainDiv.draggable=true
                    mainDiv.dataset.value=JSON.stringify(data.time)
                    data.desc ? mainDiv.dataset.desc=data.desc : null
                    mainDiv.style.width = '100px'
                    mainDiv.className = 'text-center'
        
        
                    let pTag = document.createElement('p')
                    pTag.id=evenItem.elementId
                    pTag.addEventListener('dblclick',empClick)
                    pTag.addEventListener('dragstart',drag)
                    pTag.addEventListener('contextmenu',(ev)=>deleteDiv(ev))
                    pTag.draggable=true
                    pTag.dataset.value=JSON.stringify(data.time)
                    data.desc ? pTag.dataset.desc=data.desc : null
                    pTag.style.whiteSpace= 'pre-wrap'
                    pTag.innerHTML= evenItem.elementId.split('?')[1]
                    pTag.className='bg-white'
        
                    mainDiv.appendChild(pTag)
        
                    document.getElementById(evenItem.targetId).appendChild(mainDiv)
    
                }
            })
            //toggleSpinnerModal()
        }
    }
    
    const deleteDiv = async(ev)=>{
        console.log(ev.target.dataset)
        if(ev.target.dataset.value != 'test'){
            ev.preventDefault()
            ev.persist();
            if(document.getElementById(ev.target.id)){
                //delete from DB .....
                let targetId
                let elementId
                let sTime
                elementId = ev.target.id
                sTime = JSON.parse(ev.target.dataset.value).sTime
                const resp = await deleteEvent(elementId,targetId,sTime)
                if(resp.data.success){
                    if(ev.target.tagName == 'P'){
                        //targetId = ev.target.parentElement.parentElement.id
                        ev.target.parentElement.remove()
                    }else{
                        //targetId = ev.target.parentElement.id
                        ev.target.remove()
                    }
                    setToast({type:'info',tittle:'Delete Shift',text:elementId.split('?')[1] + ' Shift was successefully deleted!'})
                }else{
                    setToast({type:'danger',tittle:'Delete Shift Error',text:'Something went wrong when deleting ' + elementId.split('?')[1] + ' Shift.Please reload the page and try again'})
                }
            }

        }
    }
    
  return (
    <>
        <Header/> 
        
        <Container>
            <Table
            innerRef={tableRef}
            hover
            responsive
            striped
            bordered
            >
                {tableHeaders()}
                
                <tbody>
                    {tableBody()}
                </tbody>
                
            </Table>
            
            <br/>
            <Button onClick={copyLastWeek}>Copy Last Week</Button>
            <Button onClick={scanTable}>Save Schedule</Button>
            <Button onClick={()=> setUsers(usersAll)} className='float-right btn-info' >View All</Button>
            <Row className='mt-2 mb-3' >
                {users && users.map((user)=>{
                    const data = user._id + '?' + user.name + '?' + user.picture
                    return empDivJsxInitial(data)
                })}
            </Row>
            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Change Time</ModalHeader>
                <ModalBody>
                    <Label>Start Time:
                    <DatePicker
                        selected={modalStartTime}
                        onChange={(date) => setModalStartTime(date)}
                        showTimeSelect
                        timeIntervals={30}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                    /></Label>
                    <Label>End Time:
                    <DatePicker
                        selected={modalEndTime}
                        onChange={(date) => setModalEndTime(date)}
                        showTimeSelect
                        timeIntervals={30}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                    /></Label>
                    <Label>Extra Info:
                        <Input type='text' value={modalDesc} onChange={(e) => setModalDesc(e.target.value)}/>
                    </Label>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={()=>saveTimeChange()}>
                        Save
                    </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            {spinnerModal ? <div style={{
                position: 'fixed', /* Stay in place */
                zIndex: 1, /* Sit on top */
                left: 0,
                top: 0,
                width: '100%', /* Full width */
                height: '100%', /* Full height */
                overflow: 'auto', /* Enable scroll if needed */
                backgroundColor: 'rgb(0,0,0)', /* Fallback color */
                backgroundColor: 'rgba(0,0,0,0.4)', /* Black w/ opacity */
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column'
            }}>
                <Spinner
                className='text-center'
                    color="primary"
                    style={{
                    height: '12rem',
                    width: '12rem',
                    }}
                    type="grow"
                >
                </Spinner>
                    <h3 >Loading...</h3>
            </div> : null}
        </Container>
        {toast && <ToastComp type={toast.type} tittle={toast.tittle} text={toast.text} />}
    </>
  )
}


export default MainSchedule